export const mutations = {
    setPesquisaSatisfacao(state, payload) {
        state.pesquisaSatisfacao = payload
    },
    setPesquisasSatisfacao(state, payload) {
        state.pesquisasSatisfacao = payload
    },
    setFormularioPesquisaSatisfacao(state, payload) {
        state.formularioPesquisaSatisfacao = payload
    },
    addPesquisaSatisfacao(state, payload){
        state.pesquisasSatisfacaos.push(payload)
    },
    removePesquisaSatisfacao(state, payload){
        let index = state.pesquisasSatisfacao.map(x => x.id).indexOf(payload.id);
        state.pesquisasSatisfacao.splice(index, 1)
    },
    setModalCadastroPesquisaSatisfacao(state, status) {
        state.modalCadastroPesquisaSatisfacao = status
    },
    setModalVisualizarPesquisaSatisfacao(state, status) {
        state.modalVisualizarPesquisaSatisfacao = status
    },
    setModalExcluirPesquisaSatisfacao(state, status) {
        state.modalExcluirPesquisaSatisfacao = status
    },
    setModalFinalizarPesquisaSatisfacao(state, status) {
        state.modalFinalizarPesquisaSatisfacao = status
    },
}

export default {}